import { Component } from '@angular/core';
import { Router, RouterModule,ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { RentalService } from 'src/app/services/rental.service';
import { RentalAssignmentService } from 'src/app/services/rental-assignment.service';
import { Observable } from 'rxjs';
import { Rental } from 'src/app/models/rental.model';

@Component({
  selector: 'app-register',
  standalone: true,
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  imports: [CommonModule, FormsModule, RouterModule],
})
export class RegisterComponent {
  email = '';
  password = '';
  firstName = '';
  lastName = '';
  phone = '';
  rentalAddress = '';
  isGoogleSignup = false;
  rentals$: Observable<Rental[]>;
  selectedRentalId: string | null =null
  error = ''
  constructor(private auth: AuthService, private router: Router, private route: ActivatedRoute,private rentalService: RentalService, private rentalAssignment: RentalAssignmentService) {}
  ngOnInit() {
    this.isGoogleSignup =
      this.route.snapshot.queryParamMap.get('provider') === 'google';
    this.rentals$ = this.rentalService.getAvailableRentals();
  }

 async register() {
  if (!this.selectedRentalId) {
    this.error = 'Please select a rental';
    return;
  }

  let uid: string;

  if (this.isGoogleSignup) {
    const user = await this.auth.completeGoogleRegistration({
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone
    });
    uid = user.uid;
  } else {
    const user = await this.auth.register(
      this.email,
      this.password,
      this.firstName,
      this.lastName,
      this.phone
    );
    uid = user.uid;
  }

  if (this.selectedRentalId && this.selectedRentalId !== 'none') {
    await this.rentalAssignment.assignRentalToUser(this.selectedRentalId, uid);
  }

  this.router.navigate(['/tenant']);
}


}
